/*
  import { sidebarMenuItems } from '@/utilities/sidebarMenuItems/Management'

  sidebarMenuItems ({
    hoaId
  })
*/

/*
  Feature List found at:
    [get] /Subscriptions/Feature/List { hoaID }
    
  Maybe partial list can be found at:
    src/utilities/Subscriptions/Features.txt
*/

/*
  toggle to turn the filter off
*/
const filter = true

import auth from '@/services/_auth'

import HouseIcon from '@/components/icons/House'
import WorkOrderIcon from '@/components/icons/WorkOrder'
import ChartIcon from '@/components/icons/Chart'
import ServicesIcon from '@/components/icons/Services'
import ViolationsIcon from '@/components/icons/Violations'
import Amenity2Icon from '@/components/icons/Amenity2'
import ManageAccountsIcon from '@/components/icons/ManageAccounts'
import DocumentIcon from '@/components/icons/Document'
import VendorsIcon from '@/components/icons/Vendors'
import SurveyIcon from '@/components/icons/Survey'
import MailingIcon from '@/components/icons/Mailing'
import ActionItemIcon from '@/components/icons/ActionItems'
import EscrowIcon from '@/components/icons/Escrow'
import EvotingIcon from '@/components/icons/Evoting'
import CustomerSupportIcon from '@/components/icons/CustomerSupport'
import BoardMeetingsIcon from '@/components/icons/BoardMeeting'
import CommunicationsIcon from '@/components/icons/Communication'

import store from '@/store'

const apps = {
  amenities: {
    to: '/amenities',
    iconC: WorkOrderIcon,
    label: 'Amenities'
  },
  architecturalRequests: {
    to: '/architecturalRequests',
    iconC: ServicesIcon,
    label: 'Architectural Requests'
  },
  properties: {
    to: '/properties',
    iconC: HouseIcon,
    label: 'Properties'
  },
  accounting: {
    to: '/accountingDashboard',
    iconC: ChartIcon,
    label: 'Accounting'
  },
  violations: {
    to: '/violations',
    iconC: ViolationsIcon,
    label: 'Violations'
  },
  workOrders: {
    to: '/workOrders',
    iconC: Amenity2Icon,
    label: 'Work Orders'
  }
}

export function sidebarMenuItems({ hoaId, enhancedFeatures }) {
  const subscribes = filter
    ? store.getters['subscription/hasHOAFeature']
    : function() {
        return true
      }

  const allowed = function(permission) {
    return auth.hasPermission(hoaId, permission)
  }

  const checkFeature = function(permission) {
    let permissionSet = false
    if (enhancedFeatures !== undefined && enhancedFeatures && enhancedFeatures.length > 0) {
      const filtered = enhancedFeatures.filter(f => f === permission)[0]
      if (filtered !== undefined && filtered) {
        permissionSet = true
      }
    }

    return permissionSet
  }

  const items = [
    ...[subscribes(57) ? apps.properties : {}],
    ...[subscribes(25) && checkFeature('amenities') === true ? apps.amenities : {}],
    ...[subscribes(31) && checkFeature('accounting') === true ? apps.accounting : {}],
    ...[
      subscribes(69) && checkFeature('architectural-requests') === true && allowed('ARCH_VIEW')
        ? apps.architecturalRequests
        : {}
    ],
    ...[
      subscribes(64) && checkFeature('violations') === true && allowed('VIO_VIEW')
        ? apps.violations
        : {}
    ],
    ...[subscribes(15) && checkFeature('work-orders') === true ? apps.workOrders : {}],

    ...(checkFeature('accounting') === true
      ? [
          {
            // feature id =
            to: '/bankAccounts',
            iconC: ManageAccountsIcon,
            label: 'Bank Accounts'
          }
        ]
      : []),

    ...(subscribes(31)
      ? [
          {
            to: '/reportsall',
            iconC: DocumentIcon,
            label: 'Reports'
          }
        ]
      : []),

    ...(subscribes(14) &&
    (checkFeature('accounting') === true || checkFeature('work-orders') === true)
      ? [
          {
            to: '/vendors',
            iconC: VendorsIcon,
            label: 'Vendors'
          }
        ]
      : []),

    ...(subscribes(58)
      ? [
          {
            to: '/communityCenter',
            iconC: SurveyIcon,
            label: 'Community Info'
          }
        ]
      : []),

    ...(checkFeature('mailing-management') === true
      ? [
          {
            // feature id =
            to: '/mailings',
            iconC: MailingIcon,
            label: 'Mailing Management'
          }
        ]
      : []),

    ...(checkFeature('action-items') === true
      ? [
          {
            // feature id =
            to: '/actionItems',
            iconC: ActionItemIcon,
            label: 'Board Action Items'
          }
        ]
      : []),

    ...(checkFeature('board-meetings') === true
      ? [
          {
            // feature id =
            to: '/boardMeetings',
            iconC: BoardMeetingsIcon,
            label: 'Board Meetings'
          }
        ]
      : []),

    ...(subscribes(53) && checkFeature('escrow') === true
      ? [
          {
            to: '/escrow',
            iconC: EscrowIcon,
            label: 'Escrow'
          }
        ]
      : []),

    ...(subscribes(53) && checkFeature('ballots') === true
      ? [
          {
            to: '/evoting',
            iconC: EvotingIcon,
            label: 'eVoting'
          }
        ]
      : []),

    ...(checkFeature('communications') === true
      ? [
          {
            to: '/communications',
            iconC: CommunicationsIcon,
            label: 'Communications'
          }
        ]
      : []),

    {
      to: '/customerSupport',
      iconC: CustomerSupportIcon,
      label: 'Customer Support'
    }
  ]

  return items
}
